import { FunctionalComponent, h } from '@stencil/core';
import { TileProps } from './tile';

export const enum layouts {
  COL2 = 'col-2',
  COL3 = 'col-3',
}

export interface TilesProps {
  tilesTitle?: string;
  tilesLabel?: string;
  layout: layouts;
  tiles?: {
    [group: string]: TileProps[];
  };
}

export const Tiles: FunctionalComponent<TilesProps> = ({ tilesTitle, tilesLabel, layout, tiles }, children) => {
  return (
    <rudy-modules-tiles tilesTitle={tilesTitle} tilesLabel={tilesLabel} layout={layout} tiles={tiles}>
      {children}
    </rudy-modules-tiles>
  );
};
